import { RitzAPI, } from '@moderepo/mode-internal-apis';
/**
 * The types of action that can be dispatched to update this sub state.
 */
export var OrganizationActionType;
(function (OrganizationActionType) {
    OrganizationActionType["SET_ORGANIZATION"] = "set org";
    OrganizationActionType["CLEAR_ORGANIZATION"] = "clear org";
})(OrganizationActionType || (OrganizationActionType = {}));
export const setOrganization = (organization) => {
    return {
        type: OrganizationActionType.SET_ORGANIZATION,
        organization,
    };
};
/**
 * Create an action to clear all organizations
 */
export const clearOrganizations = () => {
    return {
        type: OrganizationActionType.CLEAR_ORGANIZATION,
    };
};
/**
 * Get an organization by orgId
 * @param orgId - The id of the organization to look for
 */
export const fetchOrganizationById = (orgId) => {
    return async (dataDispatch) => {
        const organization = await RitzAPI.getInstance().getOrganizationById(orgId);
        await dataDispatch(setOrganization(organization));
    };
};
/**
 * Get an organization by baseUrl
 * @param baseUrl - The baseUrl of the organization to look for
 */
export const fetchOrganizationByBaseUrl = (baseUrl) => {
    return async (dataDispatch) => {
        const organization = await RitzAPI.getInstance().getOrganizationByBaseUrl(baseUrl);
        await dataDispatch(setOrganization(organization[0]));
    };
};
